import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import Aux from '../../hoc/Aux';
import { useForm, Controller } from 'react-hook-form'
import * as actions from '../../store/actions/index';
import Select from 'react-select'
import Navigation from './Navigation';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';
import useCustomTranslation from '../../hooks/useCustomTranslation';

const profile = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { register, errors, handleSubmit, control, getValues } = useForm();
  const alert = useAlert();
  const ht = useCustomHtmlTranslation();
  const ct = useCustomTranslation();

  const onSubmit = data => {
    data = {...data, country: Object(data.country).code, contactType: Object(data.contactType).code}
    dispatch( actions.saveProfile(data) ).then( (res) => {
      alert.show('Daten wurden gespeichert', {type: "success"});
     });
  };

  const myProfile = useSelector(state => {
    return () => actions.getProfile(state)
  });

  let profile = myProfile() || {};

  const intialValues = {
    firstName: profile["first_name"],
    lastName: profile["last_name"],
    company: profile["company"],
    branch: profile["branch"],
    position: profile["position"],
    street: profile["street"],
    zipcode: profile["zipcode"],
    city: profile["city"],
    country: (profile["countrycode"])? profile["countrycode"].toLowerCase() : null,
    contactType: (profile["contact_type"])? profile["contact_type"].toLowerCase() : null,
    phone: profile["phone"],
    email: profile["email"],
  };

  const countryOptions = () => actions.availableCountries.map( x => { return { code: x.toLowerCase(), label:  t('countryname_' + x) }} )
  const contactTypeOptions = () => actions.availableContactTypes.map( x => { return { code: x.toLowerCase(), label:  t('user.contact_type.' + x) }} )

  return (
    <Aux>
    	<div className="main-container">
    		<div className="container">
    			<div className="row justify-content-center mt-5">
    				<div className="col-lg-10 col-xl-9">
    					<div className="page-header">
    						<h1 className="pb-2">{ ct('userprofile.title') }</h1>
    						<span className="lead">
                  { ht('account.edit_profile') }
                </span>
    					</div>
    				</div>
    			</div>
    			<div className="row justify-content-center mt-3">
    				<div className="col-lg-3 mb-3">
              <Navigation activeItem="profile" />
    				</div>

    				<div className="col-lg-7 col-xl-6">
    					<div className="card">
    						<div className="card-body">
    							<div className="tab-content">
    								<div className="tab-pane fade show active" role="tabpanel" id="userdata">
    									<h4>{ ct('userprofile.subtitle') }</h4>
    									<form onSubmit={handleSubmit(onSubmit)}>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.first_name.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="firstName"
                              defaultValue={intialValues.firstName}
                              ref={register({ required: true, maxLength: 20 })} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.last_name.label') }</label>
    											<div className="col">
    												<input
                              className="form-control"
                              name="lastName"
                              defaultValue={intialValues.lastName}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.company.label') }</label>
    											<div className="col">
    												<input
                              className="form-control"
                              name="company"
                              defaultValue={intialValues.company}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.branch.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="branch"
                              defaultValue={intialValues.branch}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.position.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="position"
                              defaultValue={intialValues.position}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.street.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="street"
                              defaultValue={intialValues.street}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.zipcode.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="zipcode"
                              defaultValue={intialValues.zipcode}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.city.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="city"
                              defaultValue={intialValues.city}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.country.label') }</label>
    											<div className="col">
                            <Controller
                                as={Select}
                                placeholder={ ct('userprofile.form.country.placeholder') }
                                defaultValue={countryOptions().find(o => o.code === intialValues.country)}
                                options={countryOptions()}
                                getOptionLabel={option => option.label}
                                getOptionValue={option => option.code}
                                value={countryOptions().find(o => o.code === getValues("country"))}
                                onChange={([option]) => option.code}
                                name="country"
                                register={register}
                                rules={{ required: false }}
                                control={control}
                                styles={{
                                  control: (provided, { isFocused }) => ({
                                      ...provided,
                                      boxShadow: "0",
                                      fontSize: ".875rem",
                                      border: isFocused ? "1px solid #99CAFE" : "1px solid #dee2e6",
                                      ':hover': { border: "1px solid #dee2e6" }})
                                  }}
                              />
    											</div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.phone.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="phone"
                              defaultValue={intialValues.phone}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.email.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="email"
                              defaultValue={intialValues.email}
                               />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('userprofile.form.contact_type.label') }</label>
    											<div className="col">
                            <Controller
                                as={Select}
                                placeholder={ ct('userprofile.form.contact_type.placeholder') }
                                defaultValue={contactTypeOptions().find(o => o.code === intialValues.contactType)}
                                options={contactTypeOptions()}
                                getOptionLabel={option => option.label}
                                getOptionValue={option => option.code}
                                value={contactTypeOptions().find(o => o.code === getValues("contactType"))}
                                onChange={([option]) => option.code}
                                name="contactType"
                                register={register}
                                rules={{ required: false }}
                                control={control}
                                styles={
                                  (errors.country)?
                                  { control: (provided, { isFocused }) => ({
                                      ...provided,
                                      border: "1px solid red",
                                      boxShadow: "0",
                                      fontSize: ".875rem",
                                      ':hover': { border: "1px solid red" }})
                                  } : { control: (provided, { isFocused }) => ({
                                      ...provided,
                                      boxShadow: "0",
                                      fontSize: ".875rem",
                                      border: isFocused ? "1px solid #99CAFE" : "1px solid #dee2e6",
                                      ':hover': { border: "1px solid #dee2e6" }})
                                  }}
                              />
    											</div>
    										</div>

    										<div className="row justify-content-end">
    											<button type="submit" className="btn btn-primary btn-project">{ ct('userprofile.form.button.submit') }</button>
    										</div>
    									</form>
    								</div>
    							</div>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    </Aux>
  );


};

export default profile;



// WEBPACK FOOTER //
// ./src/components/User/Profile.js